import { useMemo, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { usePageContext } from 'vike-react/usePageContext';
import type { i18n as I18nInstance } from 'i18next';
import { DEFAULT_LOCALE, type SupportedLocale } from '@/lib/intl/intl.config';
import { createI18nFromResources } from './create-instance';
import type { I18nResources } from './load-resources';
import { hydrateClientI18n } from './client';

const isSsr = import.meta.env.SSR === true;
const EMPTY_RESOURCES: I18nResources = {};

export function StorefrontI18nProvider({ children }: { children: ReactNode }) {
  const pageContext = usePageContext();
  const locale = (pageContext.locale as SupportedLocale | undefined) ?? DEFAULT_LOCALE;
  const resources = (pageContext.i18nResources as I18nResources | undefined) ?? EMPTY_RESOURCES;

  const i18n = useMemo((): I18nInstance => {
    if (isSsr) {
      return createI18nFromResources(locale, resources);
    }
    return hydrateClientI18n(locale, resources);
  }, [locale, resources]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
